import { BindAll } from 'lodash-decorators'
import type { Dictionary } from 'vue-router/types/router'
import { EnumTongHaoStatus, EnumTongHaoOtherStatus } from '@xt/client/enums/kindred-spirit/index'
import { PagePagination } from '@xt/client/utils/infinite-loading/index'
import { EnumApiTonghao } from '@xt/client/api/kindred-spirit'
import { EnumApiHomework } from '@xt/client/api/homework'
import { $service } from '@xt/client/experimental/request/service'
import { toJS } from 'mobx'

type QueryParams = {
  active?: EnumTongHaoStatus | string
  otherParams?: EnumTongHaoOtherStatus | string
}

export type Moment = {
  id: string
  like: boolean | null
  likeCount: number | null
  memberId: string
  memberNickname: string
  pictures: Array<{ waterUrl: string; originWidth: number; originHeight: number; isViolation: number }>
  sourceId: number
  sourceType: number
  bizId?: number
  title: string
  top: boolean
  isViolation: boolean
  content: string
  createTime: number
  // 话题
  sourceDescription: string | null
}

@BindAll()
export class ControllerTonghao {
  pagePagination = new PagePagination({
    url: EnumApiTonghao.Moments,
    needCache: true,
    needLastId: false,
    pageSize: 20
  })

  // 点赞
  public async onLikeMoment(moment: Moment) {
    if (moment.like === true) {
      throw new Error('你已经点过赞了')
    }

    this.likeItem(moment.id)

    const [, success] = await $service<boolean>({
      url: EnumApiHomework.MomentLike,
      method: 'PUT',
      data: { momentId: moment.id }
    })

    if (success === true) {
      return
    } else {
      this.cancelLikeItem(moment.id)
      throw new Error('点赞失败')
    }
  }

  // 格式化查询参数
  public formatQuery(routerQuery: Dictionary<string | (string | null)[]>): QueryParams {
    let params = {}

    switch (routerQuery.other) {
      case '0':
        params = {
          ...params,
          otherParams: EnumTongHaoOtherStatus.Follow
        }
        break
      case '1':
        params = {
          ...params,
          otherParams: EnumTongHaoOtherStatus.Recommend
        }
        break
      default:
        params = {
          ...params
        }
        break
    }

    switch (routerQuery.active) {
      case '-1':
        params = {
          ...params,
          active: EnumTongHaoStatus.Recommend
        }
        break
      case '0':
        params = {
          ...params,
          active: EnumTongHaoStatus.InkLightUpLife
        }
        break
      case '1':
        params = {
          ...params,
          active: EnumTongHaoStatus.GoodHomework
        }
        break
      case '2':
        params = {
          ...params,
          active: EnumTongHaoStatus.StudyInsight
        }
        break
      case '3':
        params = {
          ...params,
          active: EnumTongHaoStatus.BackToHoushan
        }
        break
      case '4':
        params = {
          ...params,
          active: EnumTongHaoStatus.SnackTime
        }
        break
      case '5':
        params = {
          ...params,
          active: EnumTongHaoStatus.XuantongGathering
        }
        break
      case '6':
        params = {
          ...params,
          active: EnumTongHaoStatus.ClassmateGathering
        }
        break
      case '7':
        params = {
          ...params,
          active: EnumTongHaoStatus.ClassmateWork
        }
        break
      default:
        params = {
          ...params,
          active: EnumTongHaoStatus.Recommend
        }
        break
    }

    return params
  }

  // 转换搜索参数
  public toSearchQuery(form: QueryParams): Record<keyof QueryParams, string> {
    const obj = {} as Record<keyof QueryParams, string>

    Object.keys(form).forEach(key => {
      if (form[key].toString() !== '') {
        obj[key] = form[key].toString()
      }
    })

    return obj
  }

  // 点赞请求操作
  public likeItem(id: string) {
    const oldList = [...toJS(this.pagePagination.dataSource)]
    const newList = oldList.map(item => {
      if (item.id === id) {
        item.like = true
        item.likeCount = typeof item.likeCount === 'number' ? item.likeCount + 1 : 1
      }
      return item
    })

    this.pagePagination.updateSource(newList, dataSource => {
      return dataSource.map(item => {
        if (item.id === id) {
          item.like = true
          item.likeCount = typeof item.likeCount === 'number' ? item.likeCount + 1 : 1
        }
        return item
      })
    })
  }

  // 取消点赞操作
  public cancelLikeItem(id: string) {
    const oldList = [...toJS(this.pagePagination.dataSource)]
    const newList = oldList.map(item => {
      if (item.id === id) {
        item.like = false
        item.likeCount = typeof item.likeCount === 'number' ? Math.max(0, item.likeCount - 1) : 0
      }
      return item
    })
    this.pagePagination.updateSource(newList)
  }

  // 删除
  public removeItem(id: string) {
    const oldList = [...toJS(this.pagePagination.dataSource)]
    const newList = oldList.filter(item => item.id !== id)
    this.pagePagination.updateSource(newList)
  }
}
